import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';
import Collection from './components/Scores';
import HighScores from './components/HighScores';
import ScoresManager from './components/ScoresManager';
import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';


export default ({match, regions,roles}) => (
	<div>
		<Switch>

			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<Collection regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>

			{/*<ErrorBoundaryRoute exact path={`${match.url}/highs`}>
				<HighScores regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/manager`}>
				<ScoresManager regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>*/}

			<ErrorBoundaryRoute>
				<Redirect to={`${match.url}`} />
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);
